import React from "react";
import { Link } from "react-router-dom";
import "../styles/pages/OrdersPage.css";
import "../styles/pages/MobileMarketplace.css";
import { MobilePageHeader } from "../components/layout/MobileAppChrome";

const HelpCenterPage: React.FC = () => {
  return (
    <section className="shell section page-section">
      <div className="help-mobile-view">
        <MobilePageHeader title="Need Help?" />
        <div className="help-mobile-list">
          <a
            href="https://wa.me/919347023242?text=Hello%20Eldoo%2C%20I%20need%20help."
            target="_blank"
            rel="noreferrer"
          >
            <span>@</span>
            <div><strong>Chat with Us</strong><small>Get instant WhatsApp support</small></div>
            <b>›</b>
          </a>
          <a href="tel:+919347023242">
            <span>☎</span>
            <div><strong>Call Us</strong><small>+91 93470 23242</small></div>
            <b>›</b>
          </a>
          <a href="mailto:eldoo.service@gmail.com">
            <span>✉</span>
            <div><strong>Email Us</strong><small>eldoo.service@gmail.com</small></div>
            <b>›</b>
          </a>
          <Link to="/terms">
            <span>i</span>
            <div><strong>FAQs</strong><small>Find answers quickly</small></div>
            <b>›</b>
          </Link>
        </div>
      </div>
      <div className="section-heading">
        <div>
          <span className="eyebrow">Account</span>
          <h1>Help center</h1>
        </div>
      </div>

      <div className="orders-list">
        <article className="store-card order-card">
          <div className="order-card__header">
            <div>
              <span>Support</span>
              <h2>Need help with your account or orders?</h2>
            </div>
          </div>
          <p className="order-card__copy">
            Visit support for delivery updates, return questions, payment help, and account
            assistance.
          </p>
          <div className="order-card__actions">
            <Link className="button" to="/contact">
              Contact support
            </Link>
            <Link className="link-button" to="/bulk-order">
              Bulk order help
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
};

export default HelpCenterPage;
